import type { NavItem } from '../types';

export const navItems: NavItem[] = [
  { label: 'Dashboard', path: '/insurance' },
  { label: 'Vendor Coverage', path: '/insurance/vendors' },
  { label: 'Customer Certificates', path: '/insurance/customers' },
  { label: 'Our Policies', path: '/insurance/policies' },
  { label: 'Claims', path: '/insurance/claims' },
  { label: 'Portals', path: '/insurance/portals' },
  { label: "David's Activity", path: '/insurance/activity', requireManagerOrAdmin: true },
];
